/** Case-insensitive name-or-email match. `lowerQuery` must already be lower-cased. */
export function matchesUserQuery(user: {name?: string | null; email?: string | null}, lowerQuery: string): boolean {
	return (user.name ?? '').toLowerCase().includes(lowerQuery) || (user.email ?? '').toLowerCase().includes(lowerQuery);
}

export function userInitials(name: string | null | undefined): string {
	return (name ?? '')
		.split(/\s+/)
		.map(p => p[0] ?? '')
		.join('')
		.slice(0, 2)
		.toUpperCase();
}
